/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';

require('../front/bootstrap');

try {
  window.pushMessaging = require('./firebase').default;
} catch (e) {
  // console.error('This browser doesn\'t support the API\'s required to use the firebase SDK.');
  console.error(e.message);
}

import { store, router } from '../front/vue_config';
import VueMixins from '../front/vue_mixins';

/*
 * Add site custom routes
 */
import routes from './routes';

router.addRoutes(routes);

require('./vue_components');


//Vue.component('online-card-component', require('../front/components/Profile/OnlineCardComponent').default);

// try {
//     require("./config-" + process.env.MIX_SITE_NAME);
// } catch (e) {
//     console.log("Site config not found");
// }

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.vApp = new Vue({
  el: '#app',
  store,
  router,
  mixins: [VueMixins],
  methods: {
    afterUserLoaded: function (userId) {

    }
  }
});

